import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';



interface SessionContextProps {
  
  passwordWillExpireIn: number | 0;
  token: string | undefined;
  setPasswordWillExpireIn: React.Dispatch<React.SetStateAction<number | 0>>;
  setToken: React.Dispatch<React.SetStateAction<string | undefined>>;
  updateSession: (newToken: string) => void;
  clearSession: () => void;
}

const SessionContext = createContext<SessionContextProps | undefined>(undefined);

interface UserProviderProps {
  children: ReactNode;
}

const SessionContextProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [passwordWillExpireIn, setPasswordWillExpireIn] = useState<number>(parseInt(Cookies.get('passwordWillExpireIn') || '0'));
  const [token, setToken] = useState<string | undefined>(Cookies.get('token') || undefined);

  const getTokenExpirationTime = (token: string): number => {
    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.exp;
    } catch (error) {
      console.error('Error decoding token:', error);
      return 0;
    }
  };

  const clearSession = () => {

    setPasswordWillExpireIn(0);
    setToken(undefined);

    Cookies.remove('passwordWillExpireIn');

  };

  const updateSession = (newToken: string) => {
    setToken(newToken);
   
    const expirationTime = getTokenExpirationTime(newToken);
    const currentTime = Math.floor(Date.now() / 1000);
    const timeLeft = expirationTime - currentTime;

    if (timeLeft > 0) {
      Cookies.set('token', newToken, { expires: timeLeft / (60 * 60 * 24) });
    }
  };

  useEffect(() => {
    if (passwordWillExpireIn !== 0) Cookies.set('passwordWillExpireIn', passwordWillExpireIn.toString(), { expires: 7 });

  }, [passwordWillExpireIn]);
  return (
    <SessionContext.Provider
      value={{
        token,
passwordWillExpireIn,
        setPasswordWillExpireIn,
        setToken,

        updateSession,
        clearSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

const useSessionContext = (): SessionContextProps => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within a SessionContextProvider');
  }
  return context;
};

export { SessionContextProvider, useSessionContext };
